import { connect } from 'react-redux';
import {
  setViewAllNetworksModal,
  virtualMachinesSelectors,
} from '../../../../../../../../../../redux/configuration/virtual-machine-entities/slice';
import { RootState } from '../../../../../../../../../../redux/store';
import { ViewAllNetworksModal } from '.';

const mapDispatchToProps = {
  setViewAllNetworksModal,
};

const mapStateToProps = (state: RootState) => ({
  viewAllNetworksModal: virtualMachinesSelectors.getViewAllNetworksModal(state),
});

export type ViewAllNetworksModalProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const ViewAllNetworksModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewAllNetworksModal);
